"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayPrice = void 0;

var __1 = require("../");

var displayPrice = function displayPrice(price) {
  var country = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __1.Country.us;
  var currencyCode = __1.CurrencyCode[country];
  var locale = __1.Locale[country];
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode
  }).format(price);
};

exports.displayPrice = displayPrice;
var PricingUtilities = {
  displayPrice: exports.displayPrice
};
exports.default = PricingUtilities;